<template>
  <CRow>
    <CCard>
      <table style="width: 100%">
        <tbody>
          <tr>
            <td style="width: 25%" colspan="4">
              <h3 class="textBold">Personal Details</h3>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">
              <p class="textBold">Application ID</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.applicationId }}</p>
            </td>
            <td style="width: 25%">
              <p class="textBold">Payment Reference</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.razerpay }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">
              <p class="textBold">Job Department</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.postName }}</p>
            </td>
            <td style="width: 25%">
              <p class="textBold">Preferred Location for written test</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.preferredLocation }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%">
              <p class="textBold">Name</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.name + " " + userData.initial }}</p>
            </td>
            <td style="width: 25%">
              <p class="textBold">Place Of Birth</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.place_of_birth }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Father Name</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.fathers_name }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Gender</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.gender }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Mother Name</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.mothers_name }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Date Of Birth</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.DOB | moment }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Age</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.age }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Mobile Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.mobile }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Alternate Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.A_mobile }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Email Address</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.email }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Marital Status</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.marital_status }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Language Known</p>
            </td>
            <td style="width: 25%">
              <p v-if="userData.LK">
                <span class="textBold">Tamil:</span>
                <span v-if="userData.LK.tamil.length != 0">
                  <span v-for="i in userData.LK.tamil.length" :key="i">
                    {{ userData.LK.tamil[i - 1] }},
                  </span>
                </span>
                <span class="textBold">English:</span>
                <span v-if="userData.LK.english.length != 0">
                  <span v-for="i in userData.LK.english.length" :key="i">
                    {{ userData.LK.english[i - 1] }},
                  </span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Other Language</p>
            </td>
            <td style="width: 25%" v-if="userData.LK">
              <p v-if="userData.LK.other.length != 0">
                <span class="textBold">{{ userData.LK.other_language }}:</span>
                <span v-for="i in userData.LK.other.length" :key="i">
                  {{ userData.LK.other[i - 1] }},
                </span>
              </p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Religion</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.religion }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Aadhaar Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.aadhar }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Nationality</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.nationality }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Mother Tongue</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.mother_tongue }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Current District</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.district }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Native State</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.state }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Community</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.community }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Sub Caste</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.sub_caste }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Community Certificate Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.C_C_number }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Date of issue</p>
            </td>
            <td style="width: 25%">
              <p v-if="userData.DOI">{{ userData.DOI | moment }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Issuing Authority</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.IA }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Are you registered in employement office?</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.REO }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Priority</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.priority }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Register Date</p>
            </td>
            <td style="width: 25%">
              <p v-if="userData.REODate">{{ userData.REODate | moment }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Priority Category</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.priorityCategory }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Register Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.REONumber }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Priority Certificate Number</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.categoryCertificateNo }}</p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" colspan="4">
              <h3 class="textBold">Permanent Address</h3>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Door No</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.paDoorNo }}
              </p>
            </td>
            <td style="width: 25%">
              <p class="textBold">Street</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.paStreet }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>State</p>
            </td>
            <td style="width: 25%" colspan="3">
              <p>
                {{ userData.paState }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>District</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.paDistrict }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Taluk</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.paTaluk }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" colspan="4">
              <h3 class="textBold">Communication Address</h3>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>Door No</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.caDoorNo }}
              </p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Street</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.caStreet }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>State</p>
            </td>
            <td style="width: 25%" colspan="3">
              <p>
                {{ userData.caState }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              <p>District</p>
            </td>
            <td style="width: 25%">
              <p>{{ userData.caDistrict }}</p>
            </td>
            <td style="width: 25%" class="textBold">
              <p>Taluk</p>
            </td>
            <td style="width: 25%">
              <p>
                {{ userData.caTaluk }}
              </p>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" colspan="4">
              <h3 class="textBold">Educational Details</h3>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" colspan="4" class="textBold">
              <h3 class="textBold">SSLC Details</h3>
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification1 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.sslcPercentage }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.sslcGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.sslcTotalMarks }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.sslcYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.sslcMedium }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.sslcInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.sslcMarkSecured }}
            </td>
          </tr>

          <tr v-if="userData.hsc">
            <td style="width: 25%" colspan="4" class="textBold">
              <h3 class="textBold">+2 Details</h3>
            </td>
          </tr>
          <tr v-if="userData.hsc">
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification2 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.hscPercentage }}
            </td>
          </tr>
          <tr v-if="userData.hsc">
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.hscGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.hscTotalMarks }}
            </td>
          </tr>
          <tr v-if="userData.hsc">
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.hscYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.hscMedium }}
            </td>
          </tr>
          <tr v-if="userData.hsc">
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.hscInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.hscMarkSecured }}
            </td>
          </tr>

          <tr v-if="userData.iti">
            <td style="width: 25%" colspan="4" class="textBold">
              <h3 class="textBold">ITI Details</h3>
            </td>
          </tr>
          <tr v-if="userData.iti">
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification3 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.itiPercentage }}
            </td>
          </tr>
          <tr v-if="userData.iti">
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.itiGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.itiTotalMarks }}
            </td>
          </tr>
          <tr v-if="userData.iti">
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.itiYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.itiMedium }}
            </td>
          </tr>
          <tr v-if="userData.iti">
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.itiInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.itiMarkSecured }}
            </td>
          </tr>
          <tr v-if="userData.iti">
            <td style="width: 25%" colspan="2" class="textBold">Stream</td>
            <td style="width: 25%" colspan="2">
              {{ userData.itiStream }}
            </td>
          </tr>

          <tr v-if="userData.diploma">
            <td style="width: 25%" colspan="4" class="textBold">
              <h3 class="textBold">Diploma Details</h3>
            </td>
          </tr>
          <tr v-if="userData.diploma">
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification4 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.diplomaPercentage }}
            </td>
          </tr>
          <tr v-if="userData.diploma">
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.diplomaGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.diplomaTotalMarks }}
            </td>
          </tr>
          <tr v-if="userData.diploma">
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.diplomaYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.diplomaMedium }}
            </td>
          </tr>
          <tr v-if="userData.diploma">
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.diplomaInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.diplomaMarkSecured }}
            </td>
          </tr>
          <tr v-if="userData.diploma">
            <td style="width: 25%" colspan="2" class="textBold">Stream</td>
            <td style="width: 25%" colspan="2">
              {{ userData.diplomaStream }}
            </td>
          </tr>

          <tr v-if="userData.others">
            <td style="width: 25%" colspan="4" class="textBold">
              <h3 class="textBold">Others Details</h3>
            </td>
          </tr>
          <tr v-if="userData.others">
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification5 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.othersPercentage }}
            </td>
          </tr>
          <tr v-if="userData.others">
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.othersGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.othersTotalMarks }}
            </td>
          </tr>
          <tr v-if="userData.others">
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.othersYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.othersMedium }}
            </td>
          </tr>
          <tr v-if="userData.others">
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.othersInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.othersMarkSecured }}
            </td>
          </tr>

          <tr v-if="userData.pg">
            <td style="width: 25%" class="textBold">
              Educational Qualification
            </td>
            <td style="width: 25%">
              {{ userData.qualification6 }}
            </td>
            <td style="width: 25%" class="textBold">Percentage</td>
            <td style="width: 25%">
              {{ userData.pgPercentage }}
            </td>
          </tr>
          <tr v-if="userData.pg">
            <td style="width: 25%" class="textBold">Grade</td>
            <td style="width: 25%">
              {{ userData.pgGrade }}
            </td>
            <td style="width: 25%" class="textBold">Total Marks</td>
            <td style="width: 25%">
              {{ userData.pgTotalMarks }}
            </td>
          </tr>
          <tr v-if="userData.pg">
            <td style="width: 25%" class="textBold">Year Of Passing</td>
            <td style="width: 25%">
              {{ userData.pgYOP }}
            </td>
            <td style="width: 25%" class="textBold">Medium Of Instruction</td>
            <td style="width: 25%">
              {{ userData.pgMedium }}
            </td>
          </tr>
          <tr v-if="userData.pg">
            <td style="width: 25%" class="textBold">
              Name and Address of Institution
            </td>
            <td style="width: 25%">
              {{ userData.pgInstitution }}
            </td>
            <td style="width: 25%" class="textBold">Mark Secured</td>
            <td style="width: 25%">
              {{ userData.pgMarkSecured }}
            </td>
          </tr>

          <tr>
            <td style="width: 25%" class="textBold">
              Previous Employment Details
            </td>
            <td style="width: 25%">{{ userData.previousEmpDetails }}</td>
            <td style="width: 25%" class="textBold">
              Details of Conviction / Punishment / Disqualification / Criminal
              case,Disciplinary proceedings etc., If any
            </td>
            <td style="width: 25%">
              {{ userData.conviction }}
            </td>
          </tr>
          <tr>
            <td style="width: 25%; text-align: center !important" colspan="2">
              <h3 class="textBold">Photo</h3>
              <br />
              <img :src="userData.photo" />
            </td>
            <!-- <td style="width:25%">
                <img :src="userData.photo" />
            </td> -->
            <td style="width: 25%; text-align: center !important" colspan="2">
              <h3 class="textBold">Signature</h3>
              <br />
              <img :src="userData.signature" />
            </td>
            <!-- <td style="width:25%">
                <img :src="userData.signature" />
            </td> -->
          </tr>
        </tbody>
      </table>
    </CCard>
  </CRow>
</template>

<script>
import firebase from "firebase";
var moment = require("moment");
export default {
  data() {
    return {
      userData: {},
      isLoaded: null,
    };
  },
  methods: {
    assignData(doc) {
      let document = {
        //Personal Details
        A_mobile: doc.data().A_mobile,
        C_C_number: doc.data().C_C_number,
        DOB: doc.data().DOB ? doc.data().DOB.toDate() : "",
        DOI: doc.data().DOI ? doc.data().DOI.toDate() : "",
        IA: doc.data().IA,
        LK: doc.data().LK,
        REO: doc.data().REO,
        REODate: doc.data().REODate ? doc.data().REODate.toDate() : "",
        REONumber: doc.data().REONumber,
        aadhar: doc.data().aadhar,
        age: doc.data().age,
        district: doc.data().district,
        email: doc.data().email,
        fathers_name: doc.data().fathers_name,
        mothers_name: doc.data().mothers_name,
        gender: doc.data().gender,
        initial: doc.data().initial,
        community: doc.data().community,
        conviction: doc.data().conviction,
        marital_status: doc.data().marital_status,
        mobile: doc.data().mobile,
        mother_tongue: doc.data().mother_tongue,
        name: doc.data().name,
        nationality: doc.data().nationality,
        photo: doc.data().photo,
        religion: doc.data().religion,
        signature: doc.data().signature,
        spouseName: doc.data().spouseName,
        state: doc.data().state,
        sub_caste: doc.data().sub_caste,
        caDistrict: doc.data().caDistrict,
        caDoorNo: doc.data().caDoorNo,
        caState: doc.data().caState,
        caStreet: doc.data().caStreet,
        caTaluk: doc.data().caTaluk,
        categoryCertificateNo: doc.data().categoryCertificateNo,
        place_of_birth: doc.data().place_of_birth,
        post: doc.data().post,
        postName: doc.data().postName,
        preferredLocation: doc.data().preferredLocation,
        previousEmp: doc.data().previousEmp,
        previousEmpDetails: doc.data().previousEmpDetails,
        priority: doc.data().priority,
        priorityCategory: doc.data().priorityCategory,
        qualification1: doc.data().qualification1,
        qualification2: doc.data().qualification2,
        qualification3: doc.data().qualification3,
        qualification4: doc.data().qualification4,
        qualification5: doc.data().qualification5,
        declare: doc.data().declare,
        //Permanent Address
        paDistrict: doc.data().paDistrict,
        paDoorNo: doc.data().paDoorNo,
        paState: doc.data().paState,
        paStreet: doc.data().paStreet,
        paTaluk: doc.data().paTaluk,
        //EDUCATION - Diploma
        diploma: doc.data().diploma,
        diplomaGrade: doc.data().diplomaGrade,
        diplomaInstitution: doc.data().diplomaInstitution,
        diplomaMedium: doc.data().diplomaMedium,
        diplomaMarksheetNo: doc.data().diplomaMarksheetNo,
        diplomaMarkSecured: doc.data().diplomaMarkSecured,
        diplomaPercentage: doc.data().diplomaPercentage,
        diplomaStream: doc.data().diplomaStream,
        diplomaTotalMarks: doc.data().diplomaTotalMarks,
        diplomaYOP: doc.data().diplomaYOP,
        //EDUCATION - +2
        hsc: doc.data().hsc,
        hscGrade: doc.data().hscGrade,
        hscInstitution: doc.data().hscInstitution,
        hscMarkSecured: doc.data().hscMarkSecured,
        hscMedium: doc.data().hscMedium,
        hscPercentage: doc.data().hscPercentage,
        hscTotalMarks: doc.data().hscTotalMarks,
        hscMarksheetNo: doc.data().hscMarksheetNo,
        hscYOP: doc.data().hscYOP,
        //EDUCATION - 10
        sslcGrade: doc.data().sslcGrade,
        sslcInstitution: doc.data().sslcInstitution,
        sslcMarkSecured: doc.data().sslcMarkSecured,
        sslcMedium: doc.data().sslcMedium,
        sslcPercentage: doc.data().sslcPercentage,
        sslcTotalMarks: doc.data().sslcTotalMarks,
        sslcYOP: doc.data().sslcYOP,
        sslcMarksheetNo: doc.data().sslcMarksheetNo,
        //EDUCATION - ITI
        iti: doc.data().iti,
        itiGrade: doc.data().itiGrade,
        itiInstitution: doc.data().itiInstitution,
        itiMarkSecured: doc.data().itiMarkSecured,
        itiMedium: doc.data().itiMedium,
        itiPercentage: doc.data().itiPercentage,
        itiTotalMarks: doc.data().itiTotalMarks,
        itiMarksheetNo: doc.data().itiMarksheetNo,
        itiYOP: doc.data().itiYOP,
        itiStream: doc.data().itiStream,
        //EDUCATION - Others
        others: doc.data().others,
        othersGrade: doc.data().othersGrade,
        othersInstitution: doc.data().othersInstitution,
        othersMarkSecured: doc.data().othersMarkSecured,
        othersMedium: doc.data().othersMedium,
        othersPercentage: doc.data().othersPercentage,
        othersTotalMarks: doc.data().othersTotalMarks,
        othersMarksheetNo: doc.data().othersMarksheetNo,
        othersYOP: doc.data().othersYOP,
        //ID
        id: doc.id,
        created: doc.data().created,
        razerpay:
          doc.data().razerpay != null
            ? doc.data().razerpay["razorpay_payment_id"]
            : "Unpaid",

        applicationId: doc.data().tempapplicationId3
          ? doc.data().tempapplicationId3
          : doc.data().tempapplicationId2
          ? doc.data().tempapplicationId2
          : doc.data().applicationId,
      };
      this.userData = document;
      console.log("Applicant Data", this.userData);
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
  created() {
    const container = document.querySelector(".main-panel");
    container.scrollTop = 0;
    this.assignData(this.$route.params.preview);
  },
};
</script>

<style scoped>
p {
  margin: 0px;
}
h3 {
  margin: 0px;
}
.textBold {
  font-weight: bold;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
